var _use, _defs, _symbol;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 2.5,
    y: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: "52%",
    y1: "0%",
    x2: "48%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#387eb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffe052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffc331"
  })))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "C",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.712 0C19.403 0 20.671 8.853 20.671 8.853l.023 9.172h19.381v2.754H12.996S0 19.298 0 39.896s11.343 19.869 11.343 19.869h6.77v-9.559s-.365-11.402 11.162-11.402h19.222s10.799.175 10.799-10.492V10.674S60.936 0 39.712 0zM29.025 6.168c.925-.001 1.812.368 2.466 1.026a3.51 3.51 0 0 1 0 4.958c-.654.657-1.541 1.026-2.466 1.026s-1.812-.368-2.466-1.026a3.51 3.51 0 0 1 0-4.958c.654-.657 1.541-1.026 2.466-1.026z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.289 80c20.309 0 19.041-8.853 19.041-8.853l-.023-9.172H39.926v-2.754h27.078S80 60.703 80 40.104 68.657 20.235 68.657 20.235h-6.77v9.559s.365 11.402-11.162 11.402H31.504s-10.8-.175-10.8 10.492v17.638S19.065 80 40.289 80zm10.686-6.168c-.925.001-1.812-.368-2.466-1.026a3.51 3.51 0 0 1 0-4.958c.654-.657 1.541-1.026 2.466-1.026s1.812.368 2.466 1.026a3.51 3.51 0 0 1 0 4.958c-.654.657-1.541 1.026-2.466 1.026z",
    fill: "url(#B)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.62eb0de7b9a7bfcccba582e3b7f5405a.svg";
export { ForwardRef as ReactComponent };